import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import companies from "../../services/companies.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

class Onboarding3Controller {
  constructor($http, $localStorage, $state, AuthService, CompaniesService, SecurityService, $timeout, $rootScope, EnvService) {
    this.name = "onboarding3";

    /*
		if (!AuthService.isLoggedIn()) {
			$state.go('signin');
			return;
		};
		*/

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$timeout = $timeout;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.$env = EnvService;
    this.currentUser = this.$auth.getUserData();
    this.remain_loading_count = 0;
    // 0: nothing, 1: success to upload, 2: failed to upload
    this.uploadLogoStatus = 0;

    // 0: nothing, 1: success to register, 2: failed to register
    this.registerCardStatus = 0;
    this.isCompanyLogo = true;

    var _this = this;
    this.$rootScope.$on("SetRegisterCardStatus", function ($event, params) {
      _this.registerCardStatus = params.status;
      if (_this.registerCardStatus == 1) {
        _this.$timeout(function () {
          _this.$auth.reloadCurrentUser();
        }, 100);
      }
    });
    if (_this.currentUser) {
      if (_this.currentUser.companyProfilePictureUrl) {
        _this.currentUser.companyProfilePictureUrl = _this.currentUser.company.companyLogoUri;
      }
    } else {
      this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
    }
  }

  openFileDialog() {
    jQuery("#fileCompanyLogo").trigger("click");
  }

  uploadCompanyProfile() {
    var uploadUrlCompany =
      this.$env.getAPIEndPoint() + "jbl/v1/companies/" + this.currentUser.companyId + "/files?format=json&fileType=9&replace=true";
    this.fileToUploadCompany(this.currentUser.companyPicture, uploadUrlCompany);
  }

  fileToUploadCompany(file, uploadUrlCompany) {
    var _this = this;
    var fd = new FormData();
    fd.append("file", file);
    this.uploadLogoStatus = 0;
    _this.remain_loading_count++;
    _this.$http
      .post(uploadUrlCompany, fd, {
        transformRequest: angular.identity,
        headers: {
          "Content-Type": undefined,
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
      })
      .success(function (callback) {
        console.log("what is the callback?");
        console.dir(callback);
        if (callback.status === "error") {
          console.log("in error?");
          _this.remain_loading_count--;
          _this.reason = callback.message;
          _this.uploadLogoStatus = 2;
        } else {
          _this.currentUser.company.companyLogoUri = callback.mainFile.url;
          var photoLoop = function (value) {
            _this.$timeout(function () {
              var reloadedUser = _this.$auth.reloadCurrentUser();

              if (callback.mainFile.url === reloadedUser.$$state.value.company.companyLogoUri) {
                _this.remain_loading_count--;
                _this.uploadLogoStatus = 1;
                _this.$localStorage.logged_user = reloadedUser.$$state.value;
                _this.$rootScope.companyLogoUri = reloadedUser.$$state.value.company.companyLogoUri;
                _this.currentUser.company.companyLogoUri = reloadedUser.$$state.value.company.companyLogoUri;
              } else {
                return photoLoop(value - 1);
              }
            }, 2000);
          };
          photoLoop(10);
        }
      })
      .error(function (callback) {
        _this.remain_loading_count--;
        _this.uploadLogoStatus = 2;
        console.log("fail company logo upload");
        console.dir(callback);
      });
  }

  postEvent() {
    var _this = this;
    if (!this.$security.isUndefinedOrNull(this.currentUser.company) && this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri)) {
      this.isCompanyLogo = false;
    } else {
      this.$state.go("postevent");
    }
  }
}

Onboarding3Controller.$inject = ["$http", "$localStorage", "$state", "auth", "companies", "security", "$timeout", "$rootScope", "env"];

export default Onboarding3Controller;



// WEBPACK FOOTER //
// ./client/app/components/onboarding3/onboarding3.controller.js